import React from "react"

import { Box, Flex, Heading, Icon, RichText, Wrapper } from "components"
import headings from "components/theme/src/headings"

const Quote = ({ quote, author }) => (
  <Wrapper maxWidth={768 - 128}>
    <Box as="blockquote" m={0}>
      <Flex justifyContent="center">
        <Icon symbol="quote" size={[40, null, 48]} />
      </Flex>
      <RichText
        content={{
          html: quote,
        }}
        mt="layout.2"
        textAlign="center"
        css={{
          ...headings["600"],
        }}
      />
      {author && (
        <Box as="footer" mt="layout.2">
          <Heading
            as="cite"
            children={author}
            size={300}
            display="block"
            fontStyle="normal"
            textAlign="center"
          />
        </Box>
      )}
    </Box>
  </Wrapper>
)

export default Quote
